import { ScreeningStatus } from "./Screening";

/**
 * Normalizes raw backend status strings into the canonical lowercase statuses
 * used by the UI: ok, avert, alerte, echec, clear, faible, standard, high.
 *
 * Any unknown value is mapped to "standard" as a safe default.
 */
export function normalizeScreeningStatus(raw: string): ScreeningStatus {
  const s = String(raw || "")
    .toLowerCase()
    .trim();

  if (
    s === "ok" ||
    s === "avert" ||
    s === "alerte" ||
    s === "echec" ||
    s === "clear" ||
    s === "faible" ||
    s === "standard" ||
    s === "high"
  ) {
    return s as ScreeningStatus;
  }

  // Fallback: treat any unexpected status as STANDARD risk
  return "standard";
}
